import React from 'react';
import PropTypes from 'prop-types';
import {TextField} from 'rmwc';
import {Snackbar} from 'rmwc';

import * as styles from '../../styles';
import * as actions from './actions';
import {request} from '../../containers/actions';
import {fetchUser} from '../../containers/actions';
import { snakeCase } from 'lodash';


export default class CellPhone extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
        user: PropTypes.object,
    }

    state = {
        cellphone: this.context.user ? this.context.user.cell_phone || '' : '',
        verificationCode: '',
        verificationCounter: 0,
    };
 

    render() {
        // debugger;
        return <div style={{width: '20em', margin: 'auto',marginTop: '1em'}}>
            
            <div>
            <p style={{marginTop: '.5em'}}>
                <b>نام : </b> {this.context.user.firstname}
            </p>
            <p style={{marginTop: '.5em'}}>
                <b>نام خانوادگی : </b> {this.context.user.lastname}
            </p>
            <p style={{marginTop: '.5em'}}>
                <b>نام پدر : </b> {this.context.user.father_name}
            </p>
            <p style={{marginTop: '.5em'}}>
                <b>کد ملی : </b> {this.context.user.national_id != null ? this.context.user.national_id.persian() : ''}
            </p>
            <p style={{marginTop: '.5em'}}>
                <b>شماره تماس : </b> {this.context.user.cell_phone !=null ?  this.context.user.cell_phone.persian() : ''}
            </p>

            <p style={{marginTop: '.5em'}}>
                <b>ایمیل  : </b> {this.context.user.email}
            </p> 

            </div>

            </div>

    }
}
